{
  "Accessibility Menu": "Accessibility Menu",
  "Reset settings": "Reset All Settings",
  "Close": "Close",
  "Content Adjustments": "Content Adjustments",
  "Adjust Font Size": "Adjust Font Size",
  "Highlight Title": "Highlight Title",
  "Highlight Links": "Highlight Links",
  "Readable Font": "Readable Font",
  "Color Adjustments": "Color Adjustments",
  "Dark Contrast": "Dark Contrast",
  "Light Contrast": "Light Contrast",
  "High Contrast": "High Contrast",
  "High Saturation": "High Saturation",
  "Low Saturation": "Low Saturation",
  "Monochrome": "Monochrome",
  "Contrast": "Contrast",
  "Invert Colors": "Invert Colors",
  "Tools": "Tools",
  "Reading Guide": "Reading Guide",
  "Stop Animations": "Stop Animations",
  "Big Cursor": "Big Cursor",
  "Increase Font Size": "Increase Font Size",
  "Decrease Font Size": "Decrease Font Size",
  "Letter Spacing": "Letter Spacing",
  "Line Height": "Line Height",
  "Font Weight": "Font Weight",
  "Dyslexia Font": "Dyslexia Font",
  "Language": "Language",
  "Open Accessibility Menu": "Open Accessibility Menu",
  "Widget Settings": "Widget Settings",
  "Widget Position": "Widget Position",
  "Top Left": "Top Left",
  "Top Center": "Top Center",
  "Top Right": "Top Right",
  "Center Left": "Center Left",
  "Center Right": "Center Right",
  "Bottom Left": "Bottom Left",
  "Bottom Center": "Bottom Center",
  "Bottom Right": "Bottom Right",
  "Screen Reader": "Screen Reader",
  "Voice Navigation": "Voice Navigation",
  "Custom Color": "Custom Color",
  "Change the site's colors": "Change the site's colors",
  "Backgrounds": "Backgrounds",
  "Headings": "Headings",
  "Contents": "Contents",
  "Reset colors": "Reset colors",
  "Image Desaturation": "Image Desaturation",
  "Search languages": "Search languages",
  "No languages found": "No languages found",
  "Accessibility Profiles": "Accessibility Profiles",
  "Motor Impaired": "Motor Impaired",
  "Big cursor, voice navigation, and no animations.": "Big cursor, voice navigation, and no animations.",
  "Blind": "Blind",
  "Screen reader helpers with higher contrast.": "Screen reader helpers with higher contrast.",
  "Color Blind": "Color Blind",
  "High contrast palette with desaturated media.": "High contrast palette with desaturated media.",
  "Dyslexia": "Dyslexia",
  "Friendly font, extra spacing, stronger weight.": "Friendly font, extra spacing, stronger weight.",
  "Low vision": "Low vision",
  "Dark contrast and 130% magnification.": "Dark contrast and 130% magnification.",
  "Cognitive & Learning": "Cognitive & Learning",
  "Highlights key sections and enables voice help.": "Highlights key sections and enables voice help.",
  "Seizure & Epileptic": "Seizure & Epileptic",
  "Stops animations and desaturates imagery.": "Stops animations and desaturates imagery.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Reading guide, highlighted links, calmer palette.",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small"
}
